import { render, staticRenderFns } from "./TdInfoTag.vue?vue&type=template&id=6f7559db"
import script from "./TdInfoTag.vue?vue&type=script&lang=js"
export * from "./TdInfoTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports